<template>
    <div
        @click="$emit('select-client', conversation.client)"
        class="flex gap-4 items-top px-7 py-6 hover:bg-grey-200 cursor-pointer"
        :class="{'bg-grey-200' : isSelectedClient}"
    >
        <Avatar
            :url="conversation.client.profile_image_url"
            width="40px"
            height="40px"
        ></Avatar>

        <!-- Message preview section -->
        <div class="flex-grow flex-shrink min-w-0">
            <p class="m-b-0 n-color-text truncate" :class="headerFontWeight">
                {{ conversation.client.name }}
            </p>

            <div class="flex gap-1">
                <p v-if="conversation.is_from_user" :class="['m-b-0 n-color-text-weak', { 'font-bold': hasUnreadMessages }]">
                    {{ trans('sendables.schedule_description_receiver_you') + ':'}}
                </p>
                <p :class="['m-b-0 n-color-text-weak truncate', {'font-bold' : hasUnreadMessages}]">
                    {{ conversation.text }}
                </p>

                <!-- Attachments section -->
                <template v-if="showAttachments">
                    <i :class="['fa-paperclip-vertical mr-0 flex align-center', {'fa-light': !hasUnreadMessages, 'fa-solid': hasUnreadMessages}]"></i>

                    <span v-if="conversation.has_file" class="underline truncate" :class="{'font-bold' : hasUnreadMessages}">
                        {{ conversation.file_name }}
                    </span>

                    <span v-if="conversation.invoice" class="underline truncate">
                        {{ trans('global.invoice') }} {{ conversation.invoice.number }}
                    </span>

                    <span v-if="conversation.creditnote" class="underline truncate">
                        {{ trans('global.creditnote') }} {{ conversation.creditnote.number }}
                    </span>
                </template>
            </div>
        </div>

        <div class="flex flex-col items-end">
            <p class="m-b-5 text-sm" :class="{'font-medium' : hasUnreadMessages}">
                {{ formatDate }}
            </p>
            <i v-if="hasUnreadMessages" class="fa-solid fa-circle fa-2xs m-r-5 m-t-5 red-message-dot"></i>
        </div>

    </div>

</template>

<script>
import Avatar from '@/system/components/global/Avatar';

export default {
    components: {
        Avatar
    },

    data() {
        return {
            userLanguage: Lang.locale(),
        }
    },

    mounted() {
        this.$event_bus.$on('message-marked-as-unread', (clientId) => {
            if(clientId === this.conversation.client.id) {
                this.conversation.unread_messages_count++;
            }
        });
    },

    props: {
        conversation: {
            type: Object,
            required: true
        },
        selectedClient: {
            type: Object,
            required: false
        }
    },

    computed: {
        isSelectedClient() {
            return this.selectedClient && this.conversation.client.id === this.selectedClient.id;
        },

        headerFontWeight() {
            return this.hasUnreadMessages ? 'font-bold' : 'font-medium';
        },

        showAttachments() {
            return this.conversation.invoice || this.conversation.creditnote || this.conversation.has_file;
        },

        hasUnreadMessages() {
            return this.conversation && this.conversation.unread_messages_count > 0;
        },

        formatDate() {
            const hasLetter =/\p{L}/u;

            if (this.conversation.sent && hasLetter.test(this.conversation.sent)) {
                return this.conversation.sent;
            }

            moment.locale(this.userLanguage);

            const date = moment(this.conversation.created_at.date);
            const currentYear = moment().year();
            const dateYear = date.year();

            if (dateYear === currentYear) {
                switch (this.userLanguage) {
                    case 'sv': // Swedish
                        return date.format('D MMMM');
                    case 'da': // Danish
                        return date.format('D. MMMM');
                    case 'no': // Norwegian
                        return date.format('D. MMMM');
                    case 'fi': // Finnish
                        return date.format('D. MMMM[ta]');
                    default:
                        return date.format('MMMM Do');
                }
            } else {
                switch (this.userLanguage) {
                    case 'sv': // Swedish
                        return date.format('D MMMM YYYY');
                    case 'da': // Danish
                        return date.format('D. MMMM YYYY');
                    case 'no': // Norwegian
                        return date.format('D. MMMM YYYY');
                    case 'fi': // Finnish
                        return date.format('D. MMMM[ta] YYYY');
                    default:
                        return date.format('MMMM Do, YYYY');
                }
            }
        },
    },

}
</script>
